import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: 'input[numbersOnly]',
    standalone: false
})
export class NumberDirective {

    constructor(private _el: ElementRef) { }

    @HostListener('keyup', ['$event']) onInputChange(event: Event) {
        const initalValue = this._el.nativeElement.value;
        if (initalValue === '') {
            event.stopPropagation();
        }

        this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }

}